export const GET_ITEMS = 'GET_ITEMS'
export const SEARCH_ITEMS = 'SEARCH_ITEMS'
export const GET_ITEM_BY_CATEGORY = 'GET_ITEM_BY_CATEGORY'
export const GET_ITEMS_BY_ID = 'GET_ITEMS_BY_ID'
export const GET_PRODUCT_IMAGES = 'GET_PRODUCT_IMAGES'
export const ADD_ITEM = 'ADD_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'
export const ITEMS_LOADING = 'ITEMS_LOADING'
export const EMPTY_ITEMS = 'EMPTY_ITEMS';
export const GET_SINGLE_PRODUCT = 'GET_SINGLE_PRODUCT';
